import { Component, inject, model } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { GroupeService } from '../../../service/groupe-service';
import { ToastrService } from '../../../../shared/services/toastr-service';
import { Groupe } from '../../../model/groupe';
import { MatCardModule } from '@angular/material/card';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe, NgIf, UpperCasePipe } from '@angular/common';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Groupe
}

@Component({
  selector: 'app-groupe-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule
  ],
  templateUrl: './groupe-modal.html',
  styleUrl: './groupe-modal.css',
})
export class GroupeModal {
  readonly dialogRef = inject(MatDialogRef<GroupeModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly groupe = model(this.inputData.data!);

  groupeForm : FormGroup = new FormGroup({})

  constructor(
    private fb : FormBuilder,
    private groupeService : GroupeService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.groupeForm = this.fb.group({
      name : ['', [Validators.required]]
    })
  }

  ngAfterViewInit(): void {
    this.groupeForm.patchValue(this.inputData?.data!)
  }

  resetForm(){
    this.groupeForm.patchValue({
      name : ''
    })
  }

  onAdd(){
    this.groupeService.create(this.groupeForm.value).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    this.groupeService.update(this.groupeForm.value, this.inputData.data?.id??'').subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }
}
